/**
 * Lommebokhistorikken gruppert per dag (#156, steg 6e).
 *
 * API-et sender radene nyeste først. Gruppene beholder den rekkefølgen, og en
 * dag er enhetens kalenderdag (Oslo på familiens enheter), slik «I dag» og
 * «I går» ellers i appen regnes.
 */
import { isSameDay, startOfDay, subDays } from 'date-fns';
import type { PointTransactionRow } from './usePointsQueries';

export type DayKind = 'today' | 'yesterday' | 'other';

export interface HistoryDay {
  /** Starten på dagen, for overskriften og som nøkkel. */
  day: Date;
  kind: DayKind;
  rows: PointTransactionRow[];
}

export function groupByDay(rows: readonly PointTransactionRow[], now: Date = new Date()): HistoryDay[] {
  const today = startOfDay(now);
  const yesterday = subDays(today, 1);
  // Én gruppe per dag selv om radene skulle komme i uorden; gruppene står i
  // rekkefølgen dagen først dukker opp.
  const days = new Map<number, HistoryDay>();
  for (const row of rows) {
    const day = startOfDay(new Date(row.created_at));
    const group = days.get(day.getTime());
    if (group) {
      group.rows.push(row);
      continue;
    }
    const kind: DayKind = isSameDay(day, today) ? 'today' : isSameDay(day, yesterday) ? 'yesterday' : 'other';
    days.set(day.getTime(), { day, kind, rows: [row] });
  }
  return [...days.values()];
}
